// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".playlist{border-radius:1em;overflow:hidden;height:92%;margin-top:3%;text-align:center}.imageRadius{border:3px solid #910048;width:100%;height:100%;border-radius:15px}.image{width:100%;height:100%;border-radius:15px}.playlistName{position:absolute;top:42%;left:10%;right:5%;color:#fff;display:inline-block;font-size:2rem;line-height:2rem}", ""]);
// Exports
module.exports = exports;
